import { components } from 'react-select'
import styled from 'styled-components'

export const SelectGrid = styled(components.MenuList)`
	overflow: hidden;
	height: 300px;
	width: 300px;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	align-content: space-between;
	padding: 10px 0 10px 10px;
`

export const GridCell = styled.div`
	font-size: 10px;
	width: 25px;
	height: 25px;
	border-radius: 1px;
	background-color: #fff;
	border: ${({ isFocused, theme }) => `solid 0.5px ${isFocused ? theme.primaryColor : '#cdcdcd'}`};
	cursor: pointer;
	margin-right: 24px;
	transition: .6s;
`
